module.exports = __webpack_public_path__ + "media/warranty-claim/photos-vent2-af3714d1.png";